import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { TSizeType } from 'interfaces';

export const SIZE_STYLES: Record<TSizeType, FlattenSimpleInterpolation> = {
  huge: css`
    top: 12px;
    right: 12px;
    padding: 6px 16px;
    border-radius: 50px;
  `,
  large: css`
    top: 12px;
    right: 12px;
    padding: 6px 16px;
    border-radius: 50px;
  `,
  medium: css`
    top: 12px;
    right: 12px;
    padding: 4px 12px;
    border-radius: 50px;
  `,
  small: css`
    top: 8px;
    right: 8px;
    padding: 4px;
    border-radius: 50%;
  `
};

export const SoldBadgeImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const BadgeText = styled.div`
  color: var(--v3-black-0);
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
`;

export const SoldBadgeWrapper = styled.div<{ $size: TSizeType }>`
  position: absolute;
  color: var(--v3-black-0);
  background: #26d2d2;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 24px);
  display: flex;
  gap: 2px;
  align-items: flex-start;
  flex-direction: row;
  width: fit-content;
  height: fit-content;
  ${props => SIZE_STYLES[props.$size]}
`;
